import React, { useState } from "react";
import "../../Styles/AnnadataSukhibhavaTable.css";
import { useNavigate } from "react-router-dom";
import {
  FaSeedling,
  FaCheckCircle,
  FaRegClock,
  FaRupeeSign,
  FaSearch,
  FaMapMarkerAlt,
  FaFilter,
  FaSyncAlt,
  FaUserCircle,
  FaCalendarAlt,
  FaEdit,
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
  FaTractor,
} from "react-icons/fa";

const INITIAL_DATA = [
  {
    id: 1,
    farmerName: "Peddireddy Venkata Subbaiah",
    relation: "S/O Peddireddy Narayana Reddy",
    landExtent: "2.5 Acres",
    surveyNumber: "SY-114/2",
    amount: "₹20,000",
    village: "Gudluru",
    mandal: "Gudluru",
    date: "14-06-2026",
    status: "Approved",
  },
  {
    id: 2,
    farmerName: "Doddi Chinnaiah",
    relation: "S/O Doddi Ramaiah",
    landExtent: "1.2 Acres",
    surveyNumber: "SY-89/1",
    amount: "₹20,000",
    village: "Ulavapadu",
    mandal: "Ulavapadu",
    date: "27-05-2026",
    status: "Pending",
  },
  {
    id: 3,
    farmerName: "Marreddy Koteswara Rao",
    relation: "S/O Marreddy Subba Rao",
    landExtent: "4.0 Acres",
    surveyNumber: "SY-203/5",
    amount: "₹20,000",
    village: "Kandukur",
    mandal: "Kandukur",
    date: "05-04-2026",
    status: "Approved",
  },
];

const AdminAnnadataSukhibhavaTable = () => {
  const navigate = useNavigate();

  const [annadataData, setAnnadataData] = useState(INITIAL_DATA);

  const [searchTerm, setSearchTerm] = useState("");
  const [mandalFilter, setMandalFilter] = useState("All Mandals");
  const [statusFilter, setStatusFilter] = useState("All Status");
  const [currentPage, setCurrentPage] = useState(1);

  const [editItem, setEditItem] = useState(null);
  const [editForm, setEditForm] = useState(null);

  /* ===================== SEARCH + FILTER LOGIC ===================== */

  const filteredData = annadataData.filter((item) => {
    const matchesSearch =
      searchTerm.trim() === "" ||
      item.farmerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.relation.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.surveyNumber.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesMandal =
      mandalFilter === "All Mandals" || item.mandal === mandalFilter;

    const matchesStatus =
      statusFilter === "All Status" || item.status === statusFilter;

    return matchesSearch && matchesMandal && matchesStatus;
  });

  const handleResetFilters = () => {
    setSearchTerm("");
    setMandalFilter("All Mandals");
    setStatusFilter("All Status");
    setCurrentPage(1);
  };

  const totalEntries = filteredData.length;
  const totalPages = Math.max(1, Math.ceil(totalEntries / 10));
  const safePage = Math.min(currentPage, totalPages);
  const startIndex = (safePage - 1) * 10;
  const endIndex = startIndex + 10;
  const pageData = filteredData.slice(startIndex, endIndex);

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  /* ===================== EDIT LOGIC ===================== */

  const openEditModal = (item) => {
    setEditItem(item);
    setEditForm({ ...item });
  };

  const closeEditModal = () => {
    setEditItem(null);
    setEditForm(null);
  };

  const handleEditChange = (field, value) => {
    setEditForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleEditSave = (e) => {
    e.preventDefault();
    setAnnadataData((prev) =>
      prev.map((item) => (item.id === editForm.id ? { ...editForm } : item)),
    );
    closeEditModal();
  };

  return (
    <div className="an-page">
      {/* ── FIXED HEADER ── */}
      <div className="an-header">
        <div className="an-header-left">
          <div className="an-header-icon">
            <FaSeedling />
          </div>
          <div>
            <h2 className="an-title">Annadata Sukhibhava Beneficiaries</h2>
            <p className="an-subtitle">
              Manage and track beneficiaries under Annadata Sukhibhava Scheme
            </p>
          </div>
        </div>

        <button
          className="an-add-btn"
          onClick={() => navigate("/AdminDashboard/AnnadataSukhibhavaForm")}
        >
          <span className="an-add-plus">+</span> Add New Beneficiary
        </button>
      </div>

      {/* ── SCROLLABLE BODY ── */}
      <div className="an-scroll-body">
        {/* Stat Cards */}
        <div className="an-stats-row">
          <div className="an-stat-card">
            <div className="an-stat-icon an-icon-green">
              <FaSeedling />
            </div>
            <div>
              <p className="an-stat-label">Total Beneficiaries</p>
              <h3 className="an-stat-value">1,248</h3>
              <p className="an-stat-sub">All time records</p>
            </div>
          </div>

          <div className="an-stat-card">
            <div className="an-stat-icon an-icon-teal">
              <FaCheckCircle />
            </div>
            <div>
              <p className="an-stat-label">Approved Beneficiaries</p>
              <h3 className="an-stat-value">892</h3>
              <p className="an-stat-sub an-sub-green">71.4% of total</p>
            </div>
          </div>

          <div className="an-stat-card">
            <div className="an-stat-icon an-icon-orange">
              <FaRegClock />
            </div>
            <div>
              <p className="an-stat-label">Pending Beneficiaries</p>
              <h3 className="an-stat-value">356</h3>
              <p className="an-stat-sub an-sub-orange">28.6% of total</p>
            </div>
          </div>

          <div className="an-stat-card">
            <div className="an-stat-icon an-icon-purple">
              <FaRupeeSign />
            </div>
            <div>
              <p className="an-stat-label">Total Amount Disbursed</p>
              <h3 className="an-stat-value">₹16,80,000</h3>
              <p className="an-stat-sub an-sub-purple">All time records</p>
            </div>
          </div>
        </div>

        {/* Filter Section */}
        <div className="an-filter-section">
          <div className="an-search-wrapper">
            <FaSearch className="an-search-icon" />
            <input
              type="text"
              placeholder="Search Beneficiary..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>

          <div className="an-select-wrapper">
            <FaMapMarkerAlt className="an-select-icon" />
            <select
              value={mandalFilter}
              onChange={(e) => {
                setMandalFilter(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option>All Mandals</option>
              <option>Kandukur</option>
              <option>Gudluru</option>
              <option>Ulavapadu</option>
            </select>
          </div>

          <div className="an-select-wrapper">
            <FaFilter className="an-select-icon" />
            <select
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option>All Status</option>
              <option>Approved</option>
              <option>Pending</option>
            </select>
          </div>

          <button className="an-reset-btn" onClick={handleResetFilters}>
            <FaSyncAlt /> Reset Filters
          </button>
        </div>

        {/* Table */}
        <div className="an-table-wrapper">
          <table className="an-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Farmer Name</th>
                <th>Relation</th>
                <th>Land Extent</th>
                <th>Survey No.</th>
                <th>Amount</th>
                <th>Village</th>
                <th>Mandal</th>
                <th>Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {pageData.length > 0 ? (
                pageData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{startIndex + index + 1}</td>
                    <td>
                      <div className="an-name-cell">
                        <span className="an-avatar">
                          <FaUserCircle />
                        </span>
                        <span className="an-name-text">
                          {item.farmerName}
                        </span>
                      </div>
                    </td>
                    <td className="an-relation-cell">{item.relation}</td>
                    <td>{item.landExtent}</td>
                    <td>{item.surveyNumber}</td>
                    <td className="an-amount">{item.amount}</td>
                    <td>
                      <span className="an-village-cell">
                        <FaMapMarkerAlt /> {item.village}
                      </span>
                    </td>
                    <td>{item.mandal}</td>
                    <td>
                      <span className="an-date-cell">
                        <FaCalendarAlt /> {item.date}
                      </span>
                    </td>
                    <td>
                      <span
                        className={`an-status ${
                          item.status === "Approved"
                            ? "an-approved"
                            : "an-pending"
                        }`}
                      >
                        {item.status === "Approved" ? (
                          <FaCheckCircle />
                        ) : (
                          <FaRegClock />
                        )}{" "}
                        {item.status}
                      </span>
                    </td>
                    <td className="an-action-cell">
                      <button
                        className="an-edit-btn"
                        onClick={() => openEditModal(item)}
                      >
                        <FaEdit /> Edit
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="an-no-data">
                    No matching beneficiaries found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer / Pagination */}
        <div className="an-footer">
          <p className="an-footer-text">
            {totalEntries > 0
              ? `Showing ${startIndex + 1} to ${Math.min(
                  endIndex,
                  totalEntries,
                )} of ${totalEntries} beneficiaries`
              : "Showing 0 beneficiaries"}
          </p>

          <div className="an-pagination">
            <button
              className="an-page-btn"
              onClick={() => goToPage(safePage - 1)}
              disabled={safePage === 1}
            >
              <FaChevronLeft />
            </button>

            {Array.from({ length: totalPages }, (_, i) => i + 1).map(
              (page) => (
                <button
                  key={page}
                  className={`an-page-btn ${
                    safePage === page ? "an-page-active" : ""
                  }`}
                  onClick={() => goToPage(page)}
                >
                  {page}
                </button>
              ),
            )}

            <button
              className="an-page-btn"
              onClick={() => goToPage(safePage + 1)}
              disabled={safePage === totalPages}
            >
              <FaChevronRight />
            </button>
          </div>
        </div>

        {/* Scheme Info Banner */}
        <div className="an-scheme-banner">
          <div className="an-banner-icon-left">
            <FaTractor />
          </div>

          <div className="an-banner-text">
            <h4>Annadata Sukhibhava Scheme</h4>
            <p>
              Providing financial assistance to farmers for a better and
              sustainable agricultural future.
            </p>
          </div>
        </div>
      </div>

      {/* ===================== EDIT MODAL ===================== */}
      {editItem && editForm && (
        <div className="an-modal-overlay" onClick={closeEditModal}>
          <div
            className="an-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="an-modal-header">
              <h3>Edit Beneficiary</h3>
              <button className="an-modal-close" onClick={closeEditModal}>
                <FaTimes />
              </button>
            </div>

            <form className="an-modal-form" onSubmit={handleEditSave}>
              <div className="an-form-row">
                <label>Farmer Name</label>
                <input
                  type="text"
                  value={editForm.farmerName}
                  onChange={(e) =>
                    handleEditChange("farmerName", e.target.value)
                  }
                  required
                />
              </div>

              <div className="an-form-row">
                <label>Relation</label>
                <input
                  type="text"
                  value={editForm.relation}
                  onChange={(e) =>
                    handleEditChange("relation", e.target.value)
                  }
                  required
                />
              </div>

              <div className="an-form-grid">
                <div className="an-form-row">
                  <label>Land Extent</label>
                  <input
                    type="text"
                    value={editForm.landExtent}
                    onChange={(e) =>
                      handleEditChange("landExtent", e.target.value)
                    }
                    required
                  />
                </div>

                <div className="an-form-row">
                  <label>Survey No.</label>
                  <input
                    type="text"
                    value={editForm.surveyNumber}
                    onChange={(e) =>
                      handleEditChange("surveyNumber", e.target.value)
                    }
                    required
                  />
                </div>
              </div>

              <div className="an-form-grid">
                <div className="an-form-row">
                  <label>Amount</label>
                  <input
                    type="text"
                    value={editForm.amount}
                    onChange={(e) =>
                      handleEditChange("amount", e.target.value)
                    }
                    required
                  />
                </div>

                <div className="an-form-row">
                  <label>Status</label>
                  <select
                    value={editForm.status}
                    onChange={(e) =>
                      handleEditChange("status", e.target.value)
                    }
                  >
                    <option>Approved</option>
                    <option>Pending</option>
                  </select>
                </div>
              </div>

              <div className="an-form-grid">
                <div className="an-form-row">
                  <label>Village</label>
                  <input
                    type="text"
                    value={editForm.village}
                    onChange={(e) =>
                      handleEditChange("village", e.target.value)
                    }
                    required
                  />
                </div>

                <div className="an-form-row">
                  <label>Mandal</label>
                  <select
                    value={editForm.mandal}
                    onChange={(e) =>
                      handleEditChange("mandal", e.target.value)
                    }
                  >
                    <option>Kandukur</option>
                    <option>Gudluru</option>
                    <option>Ulavapadu</option>
                  </select>
                </div>
              </div>

              <div className="an-form-row">
                <label>Date</label>
                <input
                  type="text"
                  placeholder="DD-MM-YYYY"
                  value={editForm.date}
                  onChange={(e) => handleEditChange("date", e.target.value)}
                  required
                />
              </div>

              <div className="an-modal-actions">
                <button
                  type="button"
                  className="an-modal-cancel-btn"
                  onClick={closeEditModal}
                >
                  Cancel
                </button>
                <button type="submit" className="an-modal-save-btn">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminAnnadataSukhibhavaTable;